import React from 'react';
import "../../../styles/Salina.css"
import BackButtonPage from '../../../components/BackButtonPage';

function Salina() {
    return (
        <>


            <div className='page-content-container'>
                <p>
                    Az Adonyi székhelyű Salina Alapítvány, az 1994-óta működő Őskultúra Alapítvány új néven 
                    való továbbélése.  A Magyarországi történelmi életmódrekonstrukciós (historikus- és néprajzi 
                    ismeretterjesztő) témakör műfajteremtő és formáló műhelye, amely fő feladatának a 
                    Kárpátmedencei Magyarság tárgyi és szellemi tradícióinak jobb megismerését tekinti és keresi a 
                    hatékony tudásátörökítés lehetőségeit a magyar hadtörténetnek, a történelmi korok embereinek 
                    és a közelmúlt falusi közegének, valamint a vizes élőhelyek hagyományos életvezetési 
                    praktikáinak vonatkozásában. (kézműveség-, állattartás-, növénytermesztés-, élettér kialakítás-,
                    hadászat-, halászat/vadászat/méhészet-, önfenntartó gasztronómia,…) 
                </p>
                <p>
                    A pedagógusokból, kézművesekből, történészekből, régészekből, állattenyésztőkből és 
                    számos egyéb szakterület képviselőiből álló csoport három évtizede dolgozik a történelmi-, 
                    hadtörténeti, néprajzi ismeretterjesztés és múzeumpedagógia vonalán. A kilencvenes évek 
                    második felétől tematikus rendezvények (korismereti találkozók, kézműves programok, iskolai 
                    élő történelemórák százai, táborok, stb…) szervezésével, lebonyolításával és egy budapesti 
                    kísérletirégészeti műhely (az „EzüstFa Várudvar”) kialakításával vállalt szerepet a hazai 
                    történelmi hagyományfelelevenítő műfaj népszerűsítésében és szakmai aspektusainak erősítésében. 
                </p>
                <p>
                    2007-től 2017-ig minden esztendőben megrendezték Ópusztaszeren a NYÍLZÁPOR-t, a 
                    történelmi íjászat legnagyobb létszámú hazai találkozóját (800-1600 íjász alkalmanként).
                </p>
                <p>
                    A 2005-ös esztendőtől ezen szellemi műhely központja Szigethalmon működött. Ott építették 
                    meg és üzemeltették másfél évtizeden keresztül az Emese Park – élő múzeumfalut. Ez egy 12 
                    hektárnyi, a helyi önkormányzattól bérelt területen megvalósított un. reenacment projekt volt,
                    ami itthon egyfajta háttérsegítséget adó szakmai centrumként szolgált a koraközépkorral foglalkozó
                     történelmi hagyományfelelevenítő csoportok számára. Itt két pályázat keretében 
                    X.-XI. századi házakat, egy rönkerődítéses földvárat, egy kiállító- és előadótermet, korabeli 
                    kézműves műhelyeket építettek. Vívás-, lovaglás- és íjászoktatást, iskolai csoportos 
                    programokat, tematikus céges napokat, táborokat, nemzetközi korismereti találkozókat tartottak. 
                    Eredeti eljárásokkal építettek történelmi hajórekonstrukciókat, amelyekkel ismeretterjesztő 
                    és közösségépítő programokat tartottak.
                </p>
                <p>
                    2013-óta aktív résztvevői a Kolozsvári Magyar Napoknak, ahol egy Mátyás királyunk által
                    alapított templom kertjében minden esztendőben megjelenítenek egy közékori vásárt, 
                    interaktív programelemekkel bevonva az érdeklődőket a történelemfelidéző játékba. 
                    A 2016-os évtől az Egy hajóban evezünk projektet is a Magyar Napokat szervező Kincses 
                    Kolozsvár Egyesülettel partneri együttműködésben szervezik.
                </p>
                <p>
                    A Salina Alapítvány  “törzsgárdáját” alkotó közel 40 fős csapat mindmáig együtt tevékenykedik,
                    különböző történelmi időszakok megjelenítése által közvetítve, általuk fontossnak ítélt értékeket.
                </p>
                <p>
                    A Salina Alapítvány jelenleg is rendelkezik
                    <ul className='list'>
                        <li className='list-item'>
                            egy többszáz fős középkori haditábor minden kellékével (korhű sátrak, szekerek, vasalt 
                            ládák, asztalok, székek, zászlók, tábori kézműves műhelyek, stb…)
                        </li>
                        <li className='list-item'>
                            egy középkori folyami gálya, egy törökkori sajka és két folyami dereglye rekonstrukciójával
                        </li>
                    </ul>
                </p>
                <div className="salina-sator">
                    <img src="/assets/sator.png" alt="hajo" />
                </div>
                <BackButtonPage to="/magunkrol" />


            </div>


        </> 
    );
}

export default Salina;
